
import * as form from "../../contexts/FormContext";
import { CampaignForm } from "../../components/form/CampaignForm";

export const Form = () => {

    return (
        <form.Provider>
            <CampaignForm/>
        </form.Provider>
    )
    
}